module.exports = __webpack_public_path__ + "static/loveyou_emoji-407f2c19eb8b583cc8808530d18d5a10.svg";